import { frontendURL } from '../../../helper/URLHelper';
import {
  ensureOpportunityPipelinesEnabled,
  ensureOpportunityKanbanAccessAllowed,
} from '../../../helper/routeHelpers';
import { ACTIVITY_AGENDA_ROUTE_NAME } from '../../../helper/activityAgendaHelper';
import ActivityAgendaView from './components/agenda/ActivityAgendaView';
import OpportunityDetailsView from './components/OpportunityDetailsView';
import OpportunityKanbanView from './components/OpportunityKanbanView';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/opportunities/:opportunityId?'),
    name: 'opportunities_dashboard',
    roles: ['administrator'],
    meta: {
      hideSecondarySidebar: true,
    },
    beforeEnter: ensureOpportunityPipelinesEnabled,
    component: OpportunityDetailsView,
    props: route => ({
      opportunityId: route.params.opportunityId || null,
      conversationId: route.query.conversation_id || null,
    }),
  },
  {
    path: frontendURL('accounts/:accountId/opportunities-kanban'),
    name: 'opportunities_kanban',
    roles: ['administrator'],
    meta: {
      hideSecondarySidebar: true,
    },
    beforeEnter: ensureOpportunityKanbanAccessAllowed,
    component: OpportunityKanbanView,
  },
  {
    path: frontendURL('accounts/:accountId/opportunities-agenda'),
    name: ACTIVITY_AGENDA_ROUTE_NAME,
    roles: ['administrator'],
    meta: {
      hideSecondarySidebar: true,
    },
    beforeEnter: ensureOpportunityKanbanAccessAllowed,
    component: ActivityAgendaView,
  },
];
